import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie';


@Injectable({
  providedIn: 'root'
})
export class SharedService {
  pageData = {}
  currentPageData: any;
  constructor(){
    this.currentPageData = this.pageData/*.asObservable()*/;
  }
  get(name: string){
    if(!this.pageData[name]) {
				this.pageData[name] = {};
			}	
		return this.pageData[name];
  }

  set(pageData: any){
    this.pageData = pageData;
  }
}
